module.exports = __webpack_public_path__ + "assets/images/slide1.jpg?_2d916af3b242";